export default __webpack_public_path__ + "static/media/504.fc54cf6e.png";